webpackJsonp([129662963943619],{

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForMeStep1Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _edeq = __webpack_require__(766);
	
	var _edeq2 = _interopRequireDefault(_edeq);
	
	var _tsd = __webpack_require__(433);
	
	var _tsd2 = _interopRequireDefault(_tsd);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForMeStep1Page = function MedicareForMeStep1Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Visit your GP'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          'You must first be diagnosed with an eating disorder by a GP, paediatrician or psychiatrist. They will develop an Eating Disorder Treatment Plan for you. They will also refer you to a provider of psychological treatment. You can also receive a referral to a dietitian.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'You can complete the Eating Disorders Examination - Questionnaire (EDE-Q) below, and take the results in when you meet your GP'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', marginTop: '24px' } },
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.resourceWrapper, style: { marginRight: '24px' } },
	            _react2.default.createElement(_resourceCard.ResourceCard, {
	              key: 0,
	              background: null,
	              to: '/resource-library/eating-disorder-examination-questionnaire-ede-q',
	              audiences: [],
	              title: 'EDE-Q',
	              body: 'This is a self-report version of the Eating Disorder Examination tool which assesses eating disorder pathology.',
	              date: '1 Nov, 2019'
	            })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '/assessment?started=true' },
	            _react2.default.createElement('img', { src: _edeq2.default, style: { display: 'block', margin: '0 auto' }, alt: 'The EDE-Q assessment' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle, style: { marginRight: '24px' } },
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.titleStyle },
	            'Finding a qualified practitioner'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your GP may refer you to specific allied health professionals for mental health and dietetic services. However you can also search for clinicians in your area on our Treatment Services database.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Butterfly Foundation also have a phone line referral option 1800 33 4673'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'ANZAED also has a search for practitioner function ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.xcdsystem.com/ANZAED/member_directory/' },
	              'here'
	            ),
	            '.'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/treatment-services' },
	          _react2.default.createElement('img', { src: _tsd2.default, alt: 'The treatment services database' })
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForMeStep1Page = MedicareForMeStep1Page;

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForMeStep2Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(236);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForMeStep2Page = function MedicareForMeStep2Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#fff') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.attendStyle },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.attendTitleStyle },
	            'Attend Sessions 1-10'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.textStyle },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your eating disorders treatment plan (EDP) will initially provide access to up to 10 psychological sessions. For dietetic sessions you will get access from the outset to 20 sessions over a twelve month period. These have been made available from the beginning of your treatment plan, so if needed, you can have intensive dietetic appointments to aid with nutritional rehabilitation and refeeding early on, or you can space the 20 appointments across the 12 months. Discuss the best treatment approach for you with your dietitian.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'TIP If you and your psychologist and/or medical practitioner think that you are likely to need, and be eligible, for more than 20 psychological treatment sessions, then it is a good idea to make a booking for the mandated review with a psychiatrist or paediatrician in advance.  This review can be done at any point throughout the initial 20 session treatment course.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The specialist doctor report and recommendations must be sent to the GP before you can access sessions 20 - 40. Waitlists can be long so book in advance. These mandated reviews can be done by telehealth when eligible. Discuss with your GP.'
	            )
	          )
	        ),
	        _react2.default.createElement('img', { src: _person2.default, alt: '' })
	      )
	    )
	  );
	};
	
	exports.MedicareForMeStep2Page = MedicareForMeStep2Page;

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForMeStep3Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(3718);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForMeStep3Page = function MedicareForMeStep3Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)(), id: 'level-3' },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.titleStyle },
	            'Visit your GP'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            'At or before your 10th psychological session, you will need to go back to your GP to review your treatment progress. At this point, the GP can approve a second course of 10 psychological sessions.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#fff') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.attendStyle },
	        _react2.default.createElement('img', { src: _person2.default, alt: '' }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.attendTitleStyle },
	            'Attend Sessions 11-20'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.textStyle },
	            _react2.default.createElement(
	              'p',
	              null,
	              ' Many people with eating disorders will make positive progress and see good results within 20 sessions of evidence based treatment, and a number will even reach remission.   However, you may require longer term treatment, particularly if your illness is very longstanding, complex, or complicated by other factors.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you think you will need more than 20 sessions, then discuss booking the mandated 20 session review with a psychiatrist or peadiatritan with you mental health provider and GP, and book it if you have not already done so.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForMeStep3Page = MedicareForMeStep3Page;

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForMeStep4Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(3719);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForMeStep4Page = function MedicareForMeStep4Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)(), id: 'level-3' },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.titleStyle },
	            'Get assessed by a paediatrician or psychiatrist AND visit your GP'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            'To access the final 20 rebated psychological sessions, you need to again visit your GP for another review. Prior this review your GP will need a written report from a psychiatrist or paediatrician who has assessed you.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'TIP: It is very helpful for your psychologist or mental health practitioner to provide a report to the psychiatrist or paediatrician (and a copy to your GP) before you see them. Your psychologist will have a good understanding of the need for further treatment sessions. We have templates for these psychological reports on our website.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The psychiatrist or paediatrician needs to confirm your diagnosis, evaluate your response to therapy so far and make a recommendation as to whether further sessions are needed. If at this point you no longer meet the intake criteria because you are improving, this alone does not affect your eligibility for a further 20 sessions. The psychiatrist / paediatrician only needs to confirm your diagnosis at the time of entry to the rebated sessions and your need for further sessions'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#fff') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.attendStyle },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.attendTitleStyle },
	            'Attend Sessions 21-30'
	          ),
	          _react2.default.createElement('div', { className: _medicare.textStyle })
	        ),
	        _react2.default.createElement('img', { src: _person2.default, alt: '' })
	      )
	    )
	  );
	};
	
	exports.MedicareForMeStep4Page = MedicareForMeStep4Page;

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForMeStep5Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(3720);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForMeStep5Page = function MedicareForMeStep5Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)(), id: 'level-3' },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.titleStyle },
	            'Visit your GP'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            'At or before your 30th session, you will need to visit your GP for another review. At this point, the GP can approve a final course of up to 10 psychological sessions.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'It may seem like you need to visit your GP a lot of times during the course of treatment. However, people with eating disorders should be regularly attending a GP for medical montioring as part of treatment. So, this process can be done as part of your routine visit with your GP.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#fff') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.attendStyle },
	        _react2.default.createElement('img', { src: _person2.default, alt: '' }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.attendTitleStyle },
	            'Attend Sessions 31-40'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.textStyle },
	            _react2.default.createElement(
	              'p',
	              null,
	              'For many people up to 40 sessions of psychological treatment and 20 sessions of dietetic treatment will result in vast improvements to the eating disorder.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'However, if you require further treatment once your sessions under the eating disorders plan have finished, please discuss your options with your treating team.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForMeStep5Page = MedicareForMeStep5Page;

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StepSelect = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(372);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StepCard(_ref) {
	  var title = _ref.title,
	      onClick = _ref.onClick,
	      color = _ref.color,
	      active = _ref.active;
	
	  return _react2.default.createElement(
	    'div',
	    { onClick: onClick, style: { background: active && color || _globalStyles.lightGrey }, className: _styles.stepCardStyle },
	    title
	  );
	}
	
	function StepSelect(_ref2) {
	  var step = _ref2.step,
	      setStep = _ref2.setStep,
	      color = _ref2.color;
	
	  return _react2.default.createElement(
	    'section',
	    { className: _styles.cardsStyle },
	    _react2.default.createElement(
	      'div',
	      { className: _medicare.innerWrapperStyle, style: { display: 'flex', overflowX: 'visible' } },
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(1);
	        },
	        title: 'Initiating Treatment',
	        color: color,
	        active: step === 1
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(2);
	        },
	        title: 'Sessions 1-10',
	        color: color,
	        active: step === 2
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(3);
	        },
	        title: 'Sessions 11-20',
	        color: color,
	        active: step === 3
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(4);
	        },
	        title: 'Sessions 21-30',
	        color: color,
	        active: step === 4
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(5);
	        },
	        title: 'Sessions 31-40',
	        color: color,
	        active: step === 5
	      })
	    )
	  );
	}
	
	exports.StepSelect = StepSelect;

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stepCardStyle = exports.cardsStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var cardsStyle = /*#__PURE__*/exports.cardsStyle = (0, _emotion.css)({
	  marginBottom: '150px',
	  positon: 'relative',
	  zIndex: '1'
	});
	
	var stepCardStyle = /*#__PURE__*/exports.stepCardStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
	  position: 'relative',
	  borderRadius: '8px',
	  boxShadow: '0 6px 12px 0 rgba(0,0,0,0.18)',
	  padding: '36px 24px',
	  margin: '0 24px',
	  '&:hover': {
	    transform: 'translateY(-4px)',
	    boxShadow: '0 8px 12px 0 rgba(0,0,0,0.4)'
	  }
	}));

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/edeq.041218ce.png";

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/person-1.9f15fd84.png";

/***/ }),

/***/ 3718:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/person-2.208f3a66.png";

/***/ }),

/***/ 3719:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/person-3.fe006e55.png";

/***/ }),

/***/ 3720:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/person-4.d89a7e8b.png";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tsd.65cba321.png";

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(230);
	
	var _medicare = __webpack_require__(49);
	
	var _colouredCard = __webpack_require__(61);
	
	var _resourceCard = __webpack_require__(30);
	
	var _faq = __webpack_require__(767);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _globalStyles = __webpack_require__(4);
	
	var _step = __webpack_require__(913);
	
	var _step2 = __webpack_require__(914);
	
	var _step3 = __webpack_require__(915);
	
	var _step4 = __webpack_require__(916);
	
	var _step5 = __webpack_require__(917);
	
	var _stepSelect = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MedicareForMePage() {
	  var _useState = (0, _react.useState)(0),
	      step = _useState[0],
	      setStep = _useState[1];
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#fff') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.titleStyle, style: { color: _globalStyles.orange }, id: 'level-2' },
	            'Medicare for you'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Am I eligible?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You are eligible if you have a clinical diagnosis of Anorexia Nervosa. If you have a diagnosis of Bulimia Nervosa, Binge Eating Disorder, or Other Specified Feeding and Eating Disorders your GP will assess a couple of extra eligibility criteria. These include an assessment on the Eating Disorders Examination Questionnaire (EDE-Q) and criteria relating to medical and mental health severity.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Even if you do not meet the criteria for these items, you may still be able to access treatment under the existing Better Access to Mental Health scheme.  Please discuss your eligibility and referral options with your GP.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Eligibility Criteria for these items has been updated on the Federal Register of Legislation, you can read it in full ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.legislation.gov.au/Details/F2019L01318' },
	              'here'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/medicare/faq' },
	              _react2.default.createElement('img', { src: _faq2.default, alt: 'FAQ link' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _medicare.videoSection)(_globalStyles.orange) },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.videoDiv },
	        _react2.default.createElement(
	          'div',
	          null,
	          'How does it work?'
	        ),
	        _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/369493029', width: '640', height: '360', frameBorder: '0', allow: 'autoplay; fullscreen', allowFullScreen: true }),
	        _react2.default.createElement(
	          'div',
	          { style: { width: '250px', position: 'absolute' } },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            key: 0,
	            background: null,
	            to: '/resource-library/navigating-eating-disorders',
	            audiences: [],
	            title: 'Medicare Items Summary',
	            body: 'A one-page summary of the process for accessing treatment under the Eating Disorder Plan',
	            date: '1 Nov, 2019'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_stepSelect.StepSelect, { step: step, setStep: setStep, color: _globalStyles.orange }),
	    step === 1 && _react2.default.createElement(_step.MedicareForMeStep1Page, null),
	    step === 2 && _react2.default.createElement(_step2.MedicareForMeStep2Page, null),
	    step === 3 && _react2.default.createElement(_step3.MedicareForMeStep3Page, null),
	    step === 4 && _react2.default.createElement(_step4.MedicareForMeStep4Page, null),
	    step === 5 && _react2.default.createElement(_step5.MedicareForMeStep5Page, null)
	  );
	}
	
	exports.default = MedicareForMePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-medicare-for-me-index-js-e18a9f3a1bc413c14214.js